var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 19.25V13.75H46.75V8.25H52.25V2.75H57.75V8.25H63.25V13.75H57.75V19.25H52.25ZM30.25 48.125C33.6875 48.125 36.6094 46.9219 39.0156 44.5156C41.4219 42.1094 42.625 39.1875 42.625 35.75C42.625 32.3125 41.4219 29.3906 39.0156 26.9844C36.6094 24.5781 33.6875 23.375 30.25 23.375C26.8125 23.375 23.8906 24.5781 21.4844 26.9844C19.0781 29.3906 17.875 32.3125 17.875 35.75C17.875 39.1875 19.0781 42.1094 21.4844 44.5156C23.8906 46.9219 26.8125 48.125 30.25 48.125ZM30.25 42.625C28.325 42.625 26.6979 41.9604 25.3687 40.6312C24.0396 39.3021 23.375 37.675 23.375 35.75C23.375 33.825 24.0396 32.1979 25.3687 30.8687C26.6979 29.5396 28.325 28.875 30.25 28.875C32.175 28.875 33.8021 29.5396 35.1313 30.8687C36.4604 32.1979 37.125 33.825 37.125 35.75C37.125 37.675 36.4604 39.3021 35.1313 40.6312C33.8021 41.9604 32.175 42.625 30.25 42.625ZM8.25 57.75C6.7375 57.75 5.44271 57.2115 4.36563 56.1344C3.28854 55.0573 2.75 53.7625 2.75 52.25V19.25C2.75 17.7375 3.28854 16.4427 4.36563 15.3656C5.44271 14.2885 6.7375 13.75 8.25 13.75H16.9125L22 8.25H41.25V19.25H46.75V24.75H57.75V52.25C57.75 53.7625 57.2115 55.0573 56.1344 56.1344C55.0573 57.2115 53.7625 57.75 52.25 57.75H8.25Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/cameraPlus.8257825ece1b290eca58b2824c797cd9.svg";
export { ForwardRef as ReactComponent };